import styled from 'styled-components';
import Text from '../../base/Text';

export const TotalEvents = styled(Text).attrs(({ color }) => ({
  color: color ? color : 'states',
  size: 'small',
}))``;
